"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconWillsAndTrust = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "WillsAndTrust" }, props),
        react_1.default.createElement("title", null, "Wills and Trust"),
        react_1.default.createElement("path", { d: "M59.625 8.636L13.939 65.743l45.675 45.686 45.697-45.686L59.625 8.636zm0 71.41c-5.732 0-10.382-4.65-10.382-10.382 0-5.732 4.65-10.382 10.382-10.382 5.732 0 10.382 4.65 10.382 10.382 0 5.733-4.65 10.382-10.382 10.382z", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M49.232 69.664c0-5.732 4.65-10.382 10.382-10.382V8.646L13.93 65.754l45.685 45.675V80.046c-5.732 0-10.382-4.65-10.382-10.382z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M93.89 94.297H59.624v17.132h34.264V94.297z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M59.625 94.297H25.361v17.132h34.264V94.297z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M59.625 59.272c1.64 0 3.193.396 4.564 1.071V14.325l-4.564-5.753-4.575 5.753v46.018a10.413 10.413 0 014.575-1.072z", fill: "#000" })));
};
exports.default = BrandIconWillsAndTrust;
